import { ChangeDetectorRef, Component, Inject, NgZone, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NavigationEnd, NavigationStart, Router, RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map, filter, scan, tap } from 'rxjs/operators';
import { MetaService } from './services/meta.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'confBuild';

  constructor(
    private authService: AuthService,
    public afs: AngularFirestore,
    @Inject(Router) private router: Router,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private _ngZone: NgZone,
    private metaService: MetaService,
    public viewContainerRef: ViewContainerRef
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');

    // ---- TEMPORARILY COMMENT OUT AUTH/ROUTER LISTENER ----
    /*
    this.authService.authState
      .pipe(
        tap(user => console.log('AppComponent: authState emitted:', user))
      )
      .subscribe(async user => {
        const uid = user?.uid;

        this.router.events.pipe(
          filter((event: any) => event instanceof NavigationEnd)
        ).subscribe(x => {
          this.afs.collection("useractions").add({
            uid: uid,
            action: "navigate " + x.id + ": " + x.url,
            datetime: new Date(),
            datetimets: new Date().getTime(),
          });
        });
      });
    */
    // ---- END TEMPORARY COMMENT OUT ----
  }

  ngOnInit() {
    // Initialize meta tags with default values
    // The MetaService constructor handles this, but we inject it here to ensure it's instantiated early
  }
}







